import Vue from 'vue';
import productTransformer from '../../transformers/product';

const success = ({ data }, resolve) => resolve(productTransformer.fetch(data));

const failed = (error, reject) => reject(error);


export default id => (
  new Promise((resolve, reject) => Vue.$http.get(`vinmonopolet/products/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    }))
);



// WEBPACK FOOTER //
// ./src/app/services/vinmonopolet/findProduct.js